import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Fab, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function BackToTop() {
  const trigger = useScrollTrigger({
    target: window,
    disableHysteresis: true,
    threshold: 300,
  });

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {trigger && (
        <motion.div
          initial={{ opacity: 0, scale: 0, y: 50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0, y: 50 }}
          transition={{ 
            duration: 0.3, 
            ease: "easeOut",
            scale: { type: "spring", stiffness: 300, damping: 30 }
          }}
          style={{
            position: 'fixed',
            bottom: 32,
            right: 32,
            zIndex: 1000,
          }}
        >
          <Fab
            color="primary"
            size="medium"
            onClick={handleClick}
            sx={{
              background: 'linear-gradient(135deg, #ff3130 0%, #e02b2a 100%)',
              boxShadow: '0 8px 32px rgba(255, 49, 48, 0.3)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              '&:hover': {
                background: 'linear-gradient(135deg, #ff5554 0%, #ff3130 100%)',
                boxShadow: '0 12px 40px rgba(255, 49, 48, 0.4)',
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
            aria-label="back to top"
          >
            <KeyboardArrowUpIcon sx={{ fontSize: 24 }} />
          </Fab>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default BackToTop; 